import { createStore } from 'redux'
import { readStorage } from './Utils/storage'

// Hydrate auth-related state from localStorage so a page refresh doesn't drop the session.
// Existing login flow (src/views/pages/login/Login.js) writes these JSON-stringified.
const initialAuth = () => {
  const accessToken = readStorage('accessToken')
  return {
    // --- Auth tokens ---
    accessToken: accessToken || null,
    refreshToken: readStorage('refreshToken'),
    userName: readStorage('userName'),
    companyId: readStorage('companyId'),
    createdBy: readStorage('createdBy'),
    kpostID: readStorage('kpostID'),
    projectId: readStorage('projectId'),
    isAuthenticated: Boolean(accessToken),

    // --- User profile (populated on login / session restore via auth/setProfile) ---
    designation: '',
    memberTypes: readStorage('memberType') || '',
    userId: '',
    firstName: '',
    lastName: '',
    officialEmail: '',

    // --- Privilege map: { [menuUrl]: string[] } e.g. { '/dashboard': ['VIEW','CREATE'] } ---
    // Populated after login via GET roleMenu/{kpostId} + menu/all cross-reference.
    menuPrivileges: {},
  }
}

const initialState = {
  
  sidebarShow: false,
  sidebarUnfoldable: true,
  rightSlide: false,
  // Which view the common right-side drawer (AppHeader) shows + its payload.
  // 'conversion' (default) renders the Conversion Chart; 'bank' renders Bank Details.
  rightSlideView: 'conversion',
  rightSlideData: null,
  // Auth + profile + privileges
  ...initialAuth(),
}

const changeState = (state = initialState, { type, ...rest }) => {
  switch (type) {
    case 'set':
      return { ...state, ...rest }

    case 'auth/login':
      return { ...state, ...rest, isAuthenticated: true }

    // Populate user profile fields after login or session restore.
    // Only updates fields that are explicitly provided (undefined = keep existing).
    case 'auth/setProfile':
      return {
        ...state,
        ...(rest.designation  !== undefined && { designation:   rest.designation }),
        ...(rest.memberTypes  !== undefined && { memberTypes:   rest.memberTypes }),
        ...(rest.userId       !== undefined && { userId:        rest.userId }),
        ...(rest.firstName    !== undefined && { firstName:     rest.firstName }),
        ...(rest.lastName     !== undefined && { lastName:      rest.lastName }),
        ...(rest.officialEmail !== undefined && { officialEmail: rest.officialEmail }),
      }

    // Store the privilege map built from menu/all × roleMenu/{kpostId}.
    case 'auth/setPrivileges':
      return { ...state, menuPrivileges: rest.menuPrivileges || {} }

    case 'auth/logout':
      return {
        ...state,
        accessToken: null,
        refreshToken: null,
        userName: null,
        companyId: null,
        createdBy: null,
        kpostID: null,
        projectId: null,
        isAuthenticated: false,
        designation: '',
        memberTypes: '',
        userId: '',
        firstName: '',
        lastName: '',
        officialEmail: '',
        menuPrivileges: {},
      }

    default:
      return state
  }
}

const store = createStore(changeState)
export default store
